import { type App, defineAsyncComponent } from 'vue'

const components = {
  CalendarBacklogTray: defineAsyncComponent(() => import('./CalendarBacklogTray.vue')),
  CalendarChip: defineAsyncComponent(() => import('./CalendarChip.vue')),
  CalendarFiltersTray: defineAsyncComponent(() => import('./CalendarFiltersTray.vue')),
  CalendarToolbar: defineAsyncComponent(() => import('./CalendarToolbar.vue')),
  CalendarWeekGrid: defineAsyncComponent(() => import('./CalendarWeekGrid.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
